var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-linkedin",
    "data-name": "Icon awesome-linkedin",
    d: "M25.071,2.25H1.923A1.937,1.937,0,0,0,0,4.2V27.3A1.937,1.937,0,0,0,1.923,29.25H25.071A1.942,1.942,0,0,0,27,27.3V4.2A1.942,1.942,0,0,0,25.071,2.25ZM8.16,25.393h-4V12.508H8.166V25.393Zm-2-14.645a2.32,2.32,0,1,1,2.32-2.32,2.321,2.321,0,0,1-2.32,2.32Zm17,14.645h-4V19.125c0-1.495-.03-3.417-2.079-3.417-2.085,0-2.4,1.627-2.4,3.309v6.376h-4V12.508h3.839v1.76h.054a4.215,4.215,0,0,1,3.791-2.079c4.05,0,4.8,2.67,4.8,6.141Z",
    transform: "translate(0 -2.25)",
    fill: "var(--mainColor)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.59523355a9df47466547c64e29298c53.svg";
export { ForwardRef as ReactComponent };